module.exports = __webpack_public_path__ + "img/img_throw_1@3x_v3.1c24ccf2.png";